export const USER_ROLE_TYPES = [
    { value: "ROLE_SUPER_ADMIN",          label: "SUPER ADMIN" },
    { value: "ROLE_COMPANY_ADMIN",        label: "FİRMA ADMIN" },
    { value: "ROLE_COMPANY_ACCOUNTANT",   label: "FİRMA MUHASEBE" },
    { value: "ROLE_COMPANY_SALESPERSON",  label: "FİRMA SATIŞ" },
    { value: "ROLE_COMPANY_CASHIER",      label: "FİRMA KASİYER" },
    { value: "ROLE_ACCOUNT_ADMIN",        label: "CARİ/BAYİ ADMIN" },
    { value: "ROLE_ACCOUNT_ACCOUNTANT",   label: "CARİ/BAYİ MUHASEBE" },
];

// Plasiyer kartla tahsilatı ve ödeme linkini yalnız cari seçerek yapar; backend aksini
// 403 + data "SALESPERSON_ACCOUNT_REQUIRED" ile reddeder. Daha geniş bir rolü de olan kısıtlanmaz.
const ROLES_BROADER_THAN_SALESPERSON = ["ROLE_SUPER_ADMIN", "ROLE_COMPANY_ADMIN", "ROLE_COMPANY_ACCOUNTANT"];
export const mustSelectAccountForCollection = (roles = []) =>
    roles.includes("ROLE_COMPANY_SALESPERSON") && !roles.some((r) => ROLES_BROADER_THAN_SALESPERSON.includes(r));

// Backend'de taksit grubu oluşturma (POST /api/account-groups) yalnız bu rollere açık.
const INSTALLMENT_GROUP_CREATOR_ROLES = ["ROLE_SUPER_ADMIN", "ROLE_COMPANY_ADMIN", "ROLE_COMPANY_ACCOUNTANT"];
export const canCreateInstallmentGroup = (roles = []) =>
    roles.some((r) => INSTALLMENT_GROUP_CREATOR_ROLES.includes(r));

export const USER_ROLE_LABEL_MAP = USER_ROLE_TYPES.reduce((acc, cur) => {
    acc[cur.value] = cur.label;
    return acc;
}, {});